import Dom from '../utility/dom';

/**
 * Set window width css variable
 */
export default function setCustomProperties() {
  const setCSSProps = () => {
    // Window Size Helpers
    Dom.body.style.setProperty('--window-width', Dom.body.clientWidth + 'px');
    Dom.body.style.setProperty('--window-height', window.innerHeight + 'px');
    Dom.body.style.setProperty('--window-width-int', Dom.body.clientWidth);
    Dom.body.style.setProperty('--window-height-int', window.innerHeight);
    
    // Hero Height
    const hero = document.querySelector('.hero');
    if(hero){
      Dom.body.style.setProperty('--hero-height', hero.clientHeight + 'px');
    }
  }
  setCSSProps();

  window.addEventListener('resize', function(){
    setCSSProps();
  });
}